var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-source-select"},[_c('FrField',{attrs:{"field":_vm.dataSourceField},on:{"valueChange":function (value) { return _vm.selectDataSource(value); },"search-change":function (value) { return _vm.updateSearch(value); }},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var option = ref.option;
return [_vm._v(" "+_vm._s(option.text)+" ")]}},{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_vm._v(" "+_vm._s(option.text)+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }